import { RequestTypes } from 'legacy/lut/classes/models/onboarding/Onboarding'
import { openCreatedBpRegistration } from 'legacy/lut/components/widgets/public/onboarding/bpRegistration/helpers/openCreatedBpRegistration'
import { appGetState } from 'legacy/lut/store'
import React, { useMemo, useState } from 'react'

import { Loader } from 'core-components/library/loader'
import { ModalDialog } from 'core-components/library/modalDialog'
import { Tooltip } from 'core-components/library/tooltip'

import { createRegWithInitialData } from '../../onboarding/bpRegistration/helpers/createRegWithInitialData'
import { SpecializationSelect } from '../../onboarding/requestsInfo/requestTypes/onboarding/new/SpecializationSelect'

interface IProps {
  partnerId: string
  communicationName: string
  contactEmail: string
  contactId: string
  country: string
}

const PopupContent = (props: IProps) => {
  const requestor = useMemo(() => {
    return appGetState().user.id
  }, [])
  const [wip, setWip] = useState<boolean>(false)

  if (wip) {
    return <Loader />
  }
  return (
    <div>
      <SpecializationSelect
        partnerId={props.partnerId}
        type={RequestTypes.BPRegistration}
        onSelect={async ({ SpzCode }) => {
          setWip(true)
          const request = await createRegWithInitialData(
            SpzCode,
            props.partnerId,
            requestor,
            props.country,
            props.contactEmail,
            props.contactId
          )
          setWip(false)
          if (request.requestId) {
            openCreatedBpRegistration(request, props.communicationName)
          }
        }}
      />
    </div>
  )
}

export const BPRegistrationPopup = (props: IProps) => {
  const [showRegistrationPopup, setShowRegistrtionPopup] = useState<boolean>(false)
  return (
    <>
      <Tooltip tipContent={() => <>BP Registartion</>}>
        <i
          className="kbase kbase-edit"
          onClick={() => setShowRegistrtionPopup(true)}
          style={{
            color: '#008424',
            fontSize: '19px',
          }}
        />
      </Tooltip>
      <ModalDialog
        size={'sm'}
        onClose={() => setShowRegistrtionPopup(false)}
        content={PopupContent}
        show={showRegistrationPopup}
        contentProps={{ ...props }}
      />
    </>
  )
}
